import type { Modality, ModelStatus, PriceConfidence, QualityRank } from "../types";
import { confidenceLabel, modalityLabel, statusLabel, qualityRankLabel } from "../lib/format";

export function ModalityBadge({ value }: { value: Modality }) {
  return <span className={`badge ${value}`}>{modalityLabel(value)}</span>;
}

export function StatusBadge({ value }: { value: ModelStatus }) {
  return <span className={`badge ${value}`}>{statusLabel(value)}</span>;
}

export function ConfidenceBadge({
  value,
  jev,
}: {
  value: PriceConfidence;
  jev?: boolean;
}) {
  const cls =
    value === "verified"
      ? "verified"
      : value === "estimated"
        ? "estimated"
        : "unknown";
  return (
    <span className={`badge ${cls}`}>
      {confidenceLabel(value)}
      {jev ? <span className="jev-pill" title="Confidence judged by Jev">Jev</span> : null}
    </span>
  );
}

export function CommunityBadge({ score }: { score: number | null | undefined }) {
  if (score == null) return null;
  const tone = score >= 70 ? "ok" : score >= 40 ? "warn" : "bad";
  return (
    <span className={`badge community ${tone}`} title="Community score (Reddit/X + Jev)">
      {score}
    </span>
  );
}

export function QualityBadge({ value }: { value: QualityRank | undefined }) {
  if (!value) return null;
  return (
    <span className={`badge quality-${value}`} title="Quality rank">
      {qualityRankLabel(value)}
    </span>
  );
}
